import { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";
import { EppTricolorRingButton } from "./EppTricolorRingButton";

export function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  if (!visible) return null;

  return (
    <div className="fixed right-4 bottom-20 z-50 sm:bottom-24">
      <EppTricolorRingButton onClick={scrollToTop} aria-label="Remonter en haut de la page">
        <ChevronUp className="h-6 w-6" />
      </EppTricolorRingButton>
    </div>
  );
}
